import api from '@/lib/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'

export const useAnomalyDetailsStore = defineStore('anomalyDetails', () => {
  const errors = ref([])
  const corruptedObjects = ref('')
  const corruptedFields = ref([])
  const expandedRows = ref({})
  const loadingStuff = ref(false)
  let objects = []

  const fetchAnomalyDetails = async (anomalyId) => {
    loadingStuff.value = true
    const fieldsSet = new Set()
    const response = await api.anomalies.getAnomaly(anomalyId)
    errors.value = response.map(el => {
      if (el.object) fieldsSet.add(el.object)
      el.createddate = new Date(el.createddate)
      el.startdate = new Date(el.startdate)
      el.formattedEndDate = el.enddate ? new Date(el.enddate).toLocaleString() : ''
      el.duration.milliseconds = Math.round(el.duration.milliseconds)
      // @ts-ignore
      const duration = (new Intl.DurationFormat('en', { style: 'narrow' }).format(el.duration)).split(' ')
      el.formattedDuration = duration[0] + ' ' + (duration[1] || '')
      return el
    })
    objects = Array.from(fieldsSet).sort()
    if (!errors.value[0].formattedEndDate.length) { await checkStatus() }
    corruptedObjects.value = objects.join(', ')

    loadingStuff.value = false
  }

  const checkStatus = async () => {
    loadingStuff.value = true
    const fieldsToFix = { changeTypeFields: [], removeFields: [] }
    corruptedFields.value.forEach(obj => obj.children.forEach(el => { if (el.data.action) fieldsToFix[el.data.action].push(el.key) }))
    const { data } = await api.get(`/hk/v1/configuration/mapped-objects/check-status?objectNames=${objects}${fieldsToFix.changeTypeFields.length ? '&changeTypeFields=' + fieldsToFix.changeTypeFields.join(',') : ''}${fieldsToFix.removeFields.length ? '&removeFields=' + fieldsToFix.removeFields.join(',') : ''}`)
    if (!data) {
      loadingStuff.value = false
      return
    }
    corruptedFields.value = []
    Object.keys(data).forEach(obj => {
      const children = []
      Object.keys(data[obj]).forEach(k => {
        if (k !== 'fixed') {
          Object.keys(data[obj][k]).forEach(f => {
            children.push({ key: `${obj}.${f}`, data: { object: obj, field: f, issue: k, showRemoveColumn: true, showChangeColumn: k === 'changedType' } })
          }
          )
        }
      })
      if (children.length) {
        corruptedFields.value.push({ key: obj, data: { object: obj }, children })
      }
    })
    expandedRows.value = corruptedFields.value.reduce((acc, el) => {
      acc[el.key] = true
      return acc
    }, {})
    loadingStuff.value = false
  }

  return {
    errors,
    corruptedObjects,
    corruptedFields,
    expandedRows,
    loadingStuff,
    fetchAnomalyDetails,
    checkStatus
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAnomalyDetailsStore, import.meta.hot))
}
